export default __webpack_public_path__ + "static/media/exam-overview-level-icon.2fd3ebe0.svg";